if (!customElements.get('multi-column')) {
  class MultiColumn extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.multicolumn__items',
        pagination: '.swiper-pagination',
        nextEl: '.swiper-btn-next',
        prevEl: '.swiper-btn-prev',
      };

      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
        swiperButtonLock: 'swiper-button-lock',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);

      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
      this.enableSliderLoop = this.dataset.enableSliderLoop === 'true'; 

      this.sliderNextEl = this.section.querySelector(this.selectors.nextEl);
      this.sliderPrevEl = this.section.querySelector(this.selectors.prevEl);

      this.enableSlider = this.dataset.enableSlider === 'true';
      this.enableSliderMobile = this.dataset.enableSliderMobile === 'true';

      this.items = parseInt(this.dataset.items);
      this.mobileItems = parseInt(this.dataset.mobileItems);

      this.sliderInstance = false;

      if (!this.enableSlider && !this.enableSliderMobile) return;
      this.init();

      document.addEventListener('matchMobile', () => {
        this.init();
      });

      document.addEventListener('unmatchMobile', () => {
        this.init();
      });
    }

    init() {
      const enableSlider = FoxTheme.config.mqlMobile 
          ? this.enableSliderMobile : this.enableSlider;

      if (enableSlider) {
          this.initSlider();
      } else {
          this.destroySlider();
      }
    }

    initSlider() {
      const sliderOptions = {
        slidesPerView: parseInt(this.mobileItems),
        spaceBetween: parseInt(this.dataset.spaceBetween) / 4 || 0,
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        pagination: {
          el: this.section.querySelector(this.selectors.pagination),
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: parseInt(this.dataset.spaceBetween),
          },
          1280: {
            slidesPerView: parseInt(this.items),
            spaceBetween: parseInt(this.dataset.spaceBetween),
          },
        },
        threshold: 2,
        loop: this.enableSliderLoop,
      };

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderNextEl.classList.remove(this.classes.swiperButtonLock);
        this.sliderPrevEl.classList.remove(this.classes.swiperButtonLock);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();

        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          });
        });
      }

      if (Shopify.designMode && typeof this.sliderInstance === 'object') {
        document.addEventListener('shopify:block:select', (e) => {
          if (e.detail.sectionId != this.sectionId) return;

          const { target } = e;
          const index = Number(target.dataset.index);

          this.sliderInstance.slider.slideToLoop(index);
        });
      }
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderNextEl.classList.add(this.classes.swiperButtonLock);
      this.sliderPrevEl.classList.add(this.classes.swiperButtonLock);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);

      if (typeof this.sliderInstance === 'object') {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  }

  customElements.define('multi-column', MultiColumn);
}
